import axios from '../utils/axios';
import API_ENDPOINTS from '../constants/api-endpoints';
import { useQuery, useMutation } from 'react-query';
import util from '../utils/util';


export const useValidateToken = () => {
    return useQuery([API_ENDPOINTS.USER_VALIDATE_TOKEN], () => axios.post(API_ENDPOINTS.USER_VALIDATE_TOKEN), {
        select: (data) => data.data,
        refetchOnWindowFocus: false,
        retry: false
    });
};

export const useLogin = () => {
    return useMutation((data) => axios.post(API_ENDPOINTS.USER_LOGIN, data), {
        onSuccess: ({ data }) => {
            util.setUserData(data);
            window.location.reload();
        }
    });
};

export const useProfileData = () => {
    return useQuery([API_ENDPOINTS.USER_PROFILE_GET], () => axios.get(API_ENDPOINTS.USER_PROFILE_GET), {
        select: (data) => data.data
    });
};

export const useUpdateProfileData = ({ onSuccess }) => {
    return useMutation((data) => axios.post(API_ENDPOINTS.USER_PROFILE_SAVE, data), {
        select: (data) => data.data,
        onSuccess: onSuccess
    });
}

export const useUpdatePassword = () => {
    return useMutation((data) => axios.post(API_ENDPOINTS.USER_UPDATE_PASSWORD, data), {
        select: (data) => data.data
    });
}